import Icon from "@material-ui/icons/SupervisedUserCircle";
import UnapprovedInvoiceList from "./UnapprovedInvoiceList";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "unapprovedInvoices",
  list: UnapprovedInvoiceList,
  icon: Icon,
};
